import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { StyleModule } from '../../style/style.module';
import { ThingTroubleshootingModule } from '../../widget/thing-troubleshooting/thing-troubleshooting.module';
import { AlertWorkSessionDetailsModule } from '../alert-work-session-details-page-dialog/alert-work-session-details.module';
import { EventDetailsOccurrencesComponent } from './event-details-occurrences.component';
import { EventDetailsPageDialogComponent } from './event-details-page-dialog.component';
import { EventDetailsSectionComponent } from './event-details-section.component';
import { EventDetailsTemplateComponent } from './event-details-template.component';
import { EventDetailsTimelineComponent } from './event-details-timeline.component';
import { EventDetailsTroubleshootingComponent } from './event-details-troubleshooting.component';

@NgModule({
    imports: [
        RouterModule,
        SharedModule,
        StyleModule,
        AlertWorkSessionDetailsModule,
        ThingTroubleshootingModule
    ],
    exports: [EventDetailsPageDialogComponent, EventDetailsSectionComponent],
    declarations: [
        EventDetailsPageDialogComponent,
        EventDetailsSectionComponent,
        EventDetailsTemplateComponent,
        EventDetailsTimelineComponent,
        EventDetailsOccurrencesComponent,
        EventDetailsTroubleshootingComponent
    ],
    providers: []
})
export class EventDetailsPageDialogModule { }